"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CLEANSE_STANDARDIZE_DATA", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CLEANSE_STANDARDIZE_DATA;
  }
});
Object.defineProperty(exports, "MERGE_DUPLICATES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MERGE_DUPLICATES;
  }
});
Object.defineProperty(exports, "DATA_FORMATING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DATA_FORMATING;
  }
});
Object.defineProperty(exports, "BULK_UPDATES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BULK_UPDATES;
  }
});
Object.defineProperty(exports, "DATA_IMPORT_EXPORT_TOOLS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DATA_IMPORT_EXPORT_TOOLS;
  }
});
Object.defineProperty(exports, "ETL", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ETL;
  }
});
Object.defineProperty(exports, "MULTIPLE_DATA_SOURCES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MULTIPLE_DATA_SOURCES;
  }
});
Object.defineProperty(exports, "WORKFLOW_AUTOMATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.WORKFLOW_AUTOMATION;
  }
});
Object.defineProperty(exports, "DATA_MIGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DATA_MIGRATION;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/DataManagement.js
// module id = 566
// module chunks = 209 210 211 212 213